import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface DialogModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  contentText: string;
  closeAction?: () => void;
  isMultiLine?: boolean;
}

export function SimpleMessageDialog(props: DialogModalProps) {
  const { open, setOpen, title, contentText, isMultiLine = false } = props;
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {isMultiLine && contentText.includes('\n') && (
            <div>
              {contentText.split('\n').map((i, key) => {
                return <div key={key}>{i}</div>;
              })}
            </div>
          )}
          {!isMultiLine && <div>{contentText}</div>}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('button.ok')}</Button>
      </DialogActions>
    </Dialog>
  );
}
